import {
    setEffectParameterValues,
    moveEngineAutomations,
} from 'actions/index.js';

export default superclass => class extends superclass  {
    resetAutomationParameters() {
        /*
        let mixSchedulers = 
            this.state.automation.automationMixSchedulers[this.sequenceId] || {};
        let bulk = {};
        for (let id in mixSchedulers) {
            let automation = mixSchedulers[id];

            let {parameter, initialValue} = automation;
            if (initialValue !== undefined) {
                let {id, value} = parameter.set(
                    initialValue,
                    true,
                    true);
                bulk[id] = value;
            }
        }

        if (Object.keys(bulk).length > 0) {
            console.log("resetting automation parameters = ", bulk);
            this.store.dispatch(setEffectParameterValues(bulk));
        }
        */
    }

    clearScheduledAutomations() {
        let patternSchedulers = this.state.automation.automationSchedulers[this.sequenceId] || {};
        let mixSchedulers = 
            this.state.automation.automationMixSchedulers[this.sequenceId] || {};
        let schedulers = {... patternSchedulers, ... mixSchedulers};
        let bulk = {};
        for (let i in schedulers) {
            schedulers[i].clear();
            if (schedulers[i].parameter) {
                let ret = schedulers[i].parameter.updateRedux();
                if (ret) {
                    let {id, value} = ret;
                    bulk[id] = value;
                }
            }
        }
        if (Object.keys(bulk).length > 0) {
            this.store.dispatch(setEffectParameterValues(bulk));
        }
    }

    scheduleParameterAutomations(currentStep, time, isFirstStep) {
        if (this.multiSequencerEngine) {
            currentStep = this.multiSequencerEngine.trackStep;
        }

        let patternSchedulers = this.state.automation.automationSchedulers[this.sequenceId] || {};
        let mixSchedulers = this.state.mix.isPlayingMix ?
            this.state.automation.automationMixSchedulers[this.sequenceId] || {} :
            {};
        let schedulers = {... patternSchedulers, ... mixSchedulers};
        let bulk = {};
        for (let i in schedulers) {
            let scheduler = schedulers[i];
            let {parameter} = scheduler;
            if (parameter === undefined) {
                continue;
            }
            if (scheduler.isMix && !this.state.mix.isPlayingMix) {
                continue;
            }
            let {track} = parameter;
            let length = this.length;
            if (track !== undefined) {
                if (track.instrumentRack) {
                    track = track.instrumentRack;
                }
                if (track.pattern === undefined) {
                    // that means its disposed
                    continue;
                }
                length = track.length;
            }

            if (scheduler.isMix) {
                // only schedule if theres shit to schedule in the next
                if (isFirstStep) {
                    scheduler.start(time);
                }

                if (scheduler.eventIds.length === 0 &&
                    scheduler.automations.some(
                        e => e.step >= currentStep &&
                            e.step < currentStep + 32)) {
                    // we have an automation coming up so schedule the automations
                    scheduler.schedule(currentStep, time, Math.max(0, time - 0.001));
                }
            } else if (currentStep % length === 0) {
                // then we need to schedule
                scheduler.schedule(currentStep, time);
            }

            parameter.onNewStep(currentStep);

            // now we want to notify redux about all the parameter changes
            // that may have resulted from automation on this step

            if (parameter.context && parameter.context.macro) {
                // get all sub parameters and update their values/do new step
                let {subMacros} = parameter.context.macro;
                for (let i in subMacros) {
                    let {parameter} = subMacros[i];
                    parameter.onNewStep(currentStep);
                    bulk[parameter.id] = parameter.getAtStep(currentStep);
                }
            }

            if (this.trackStep % 2 === 0) {
                let sliderDown = this.state.automation.parameterSliderDown;
                if (sliderDown.indexOf(parameter) === -1 &&
                    scheduler.automations.length > 0) {
                    // when slider is down we dont update redux with the
                    // automation value
                    if (!scheduler.isMix || scheduler.hasEventsAfterStep(currentStep)) {
                        bulk[parameter.id] = scheduler.getValueAtStep(currentStep);
                    }
                }
            }
        }

        // only bulk update on 1/16th notes (for efficiency)
        if (this.trackStep % 2 === 0) {
            if (Object.keys(bulk).length > 0) {
                this.store.dispatch(setEffectParameterValues(bulk));
            }
        }
    }

    updateAutomationRedux(oldId, newId) {
        this.store.dispatch(moveEngineAutomations(oldId, newId));
    }
}
